module.exports = __webpack_public_path__ + "static/img/background.ca2791cd.svg";